<template>
  <div>
    <v-menu transition="slide-x-transition" bottom right :data-menu="item.id">
      <template v-slot:activator="{on, attrs}">
        <div v-bind="attrs" v-on="on" :data-cy="`actionsMenu${tableList.indexOf(item)}`">
          <v-icon class="icon-mapit">)</v-icon>
        </div>
      </template>
      <v-list dense class="list-menu-actions">
        <v-list-item
          :data-cy="`resendSignHandoverEmailAction${tableList.indexOf(item)}`"
          @click="resendSignHandoverEmail(item.id)"
          :disabled="item.status !== LoanStatus.Started">
          <v-list-item-title>
            {{ $t('dealer-bike.loans.actions.resend-sign-handover-email') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :data-cy="`signHandOverLoanAction${tableList.indexOf(item)}`"
          @click="markHandOverLoanAsSigned(item.id)"
          :disabled="item.status !== LoanStatus.Started">
          <v-list-item-title>
            {{ $t('dealer-bike.loans.actions.sign-handover-loan-paper') }}
          </v-list-item-title>
        </v-list-item>
        <v-divider class="drawer-divider"></v-divider>
        <v-list-item
          :data-cy="`makeReturnAction${tableList.indexOf(item)}`"
          @click="makeReturn(item)"
          :disabled="item.status !== LoanStatus.HandedOver">
          <v-list-item-title>
            {{ $t('dealer-bike.loans.actions.make-return') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :data-cy="`resendSignReturnEmailAction${tableList.indexOf(item)}`"
          @click="resendSignReturnEmail(item.id)"
          :disabled="item.status !== LoanStatus.Returned">
          <v-list-item-title>
            {{ $t('dealer-bike.loans.actions.resend-sign-return-email') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :data-cy="`signReturnLoanAction${tableList.indexOf(item)}`"
          @click="markReturnLoanAsSigned(item.id)"
          :disabled="item.status !== LoanStatus.Returned">
          <v-list-item-title>
            {{ $t('dealer-bike.loans.actions.sign-return-loan-paper') }}
          </v-list-item-title>
        </v-list-item>
        <v-divider class="drawer-divider"></v-divider>
        <download-loan-list-item
          :data-cy="`download-handover-document-${item.id}`"
          :loan="item"
          :label="$t('dealer-bike.loans.actions.download-handover-document')"
          @toggleDialog="toggleDialogWaitingDocs" />
        <v-divider class="drawer-divider"></v-divider>
        <v-list-item
          :data-cy="`cancelled-${item.id}`"
          @click="markLoanAsCancelled(item.id)"
          :disabled="item.status === LoanStatus.Cancelled">
          <v-list-item-title>
            {{ $t('dealer-bike.loans.actions.cancelled-loan') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <mapit-dialog :dialog="dialogMarkHandOverLoanSigned" :hideCloseButton="true">
      <template v-slot:header-icon>
        <v-icon class="icon-mapit" color="secondary">O</v-icon>
      </template>
      <template v-slot:header-text>
        <div class="text-center" v-balance-text>{{ $t('dealer-bike.loans.sign-handover-loan-paper.title') }}</div>
      </template>
      <template v-slot:body>
        <div class="text-center" v-balance-text>
          {{ $t('dealer-bike.loans.sign-handover-loan-paper.body') }}
        </div>
      </template>
      <template v-slot:footer-center>
        <v-btn :loading="loading" :disabled="loading" class="btn-primary" @click="signLoan">{{
          $t('buttons.confirm')
        }}</v-btn>
        <v-btn
          data-cy="btn-cancel-dialog-mark-hand-over-loan-signed"
          class="btn-gray"
          @click="dialogMarkHandOverLoanSigned = !dialogMarkHandOverLoanSigned"
          >{{ $t('buttons.cancel') }}</v-btn
        >
      </template>
    </mapit-dialog>

    <mapit-dialog :dialog="dialogMarkReturnLoanSigned" :hideCloseButton="true">
      <template v-slot:header-icon>
        <v-icon class="icon-mapit" color="secondary">O</v-icon>
      </template>
      <template v-slot:header-text>
        <div class="text-center" v-balance-text>{{ $t('dealer-bike.loans.sign-return-loan-paper.title') }}</div>
      </template>
      <template v-slot:body>
        <div class="text-center" v-balance-text>
          {{ $t('dealer-bike.loans.sign-return-loan-paper.body') }}
        </div>
      </template>
      <template v-slot:footer-center>
        <v-btn
          :loading="loading"
          :disabled="loading"
          class="btn-primary"
          @click="signReturn"
          :data-cy="`btn-mark-return-signed-${loanId}`"
          >{{ $t('buttons.confirm') }}</v-btn
        >
        <v-btn
          class="btn-gray"
          @click="dialogMarkReturnLoanSigned = !dialogMarkReturnLoanSigned"
          :data-cy="`btn-cancel-${loanId}`"
          >{{ $t('buttons.cancel') }}</v-btn
        >
      </template>
    </mapit-dialog>

    <mapit-dialog :dialog="dialogCancelledLoan" :hideCloseButton="true">
      <template v-slot:header-icon>
        <v-icon class="text-orange"> fa fa-exclamation-triangle</v-icon>
      </template>
      <template v-slot:header-text>
        <div class="text-center" v-balance-text>{{ $t('dealer-bike.loans.cancelled.title') }}</div>
      </template>
      <template v-slot:body>
        <div class="text-center">
          <div v-balance-text>{{ $t('dealer-bike.loans.cancelled.body-top') }}</div>
        </div>
      </template>
      <template v-slot:footer-center>
        <v-btn :loading="loading" :disabled="loading" class="btn-primary" @click="doCancelledLoan()">{{
          $t('buttons.confirm')
        }}</v-btn>
        <v-btn class="btn-gray" @click="dialogCancelledLoan = !dialogCancelledLoan">{{ $t('buttons.cancel') }}</v-btn>
      </template>
    </mapit-dialog>

    <mapit-dialog :dialog="isOpenDialogWaitingDocs" :hideCloseButton="true" @close="toggleDialogWaitingDocs()">
      <template v-slot:header-icon>
        <v-icon color="warning">fa-solid fa-warning</v-icon>
      </template>
      <template v-slot:header-text>
        <div class="text-center" v-balance-text>
          {{ $t('dealer-bike.loans.popups.waiting-docs.title') }}
        </div>
      </template>
      <template v-slot:body>
        <div
          v-balance-text.children
          class="dialog-body mt-5"
          v-html="
            $t('dealer-bike.loans.popups.waiting-docs.body', {
              type:
                selectedLoan && selectedLoan.returnedAt
                  ? $t('dealer-bike.loans.popups.waiting-docs.type-return')
                  : $t('dealer-bike.loans.popups.waiting-docs.type-handover'),
            })
          " />
      </template>
      <template v-slot:footer-center>
        <v-btn data-cy="btnDialogWaitingDocs" class="btn-primary" @click="toggleDialogWaitingDocs()">
          {{ $t('buttons.accept') }}
        </v-btn>
      </template>
    </mapit-dialog>
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from '@vue/composition-api'

import DownloadLoanListItem from '@/components/atom/DownloadLoanListItem.vue'
import MapitDialog from '@/components/dialog/MapitDialog.vue'
import {LoanStatus} from '@/types/dealer-bikes'

export default defineComponent({
  name: 'LoansTableActions',
  props: {
    item: {
      type: Object,
      required: true,
    },
    tableList: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    MapitDialog,
    DownloadLoanListItem,
  },
  setup(_, {root, emit}) {
    const resendSignHandoverEmail = (itemId: string) => root.$store.dispatch('resendSignHandoverEmail', itemId)
    const resendSignReturnEmail = (itemId: string) => root.$store.dispatch('resendSignReturnEmail', itemId)
    const signHandOverLoan = (itemId: string) => root.$store.dispatch('signHandOverLoan', itemId)
    const signReturnLoan = (loanId: string) => root.$store.dispatch('signReturnLoan', loanId)
    const cancelledLoan = (loanId: string) => root.$store.dispatch('cancelledLoan', loanId)
    const dialogMarkHandOverLoanSigned = ref<boolean>(false)
    const dialogMarkReturnLoanSigned = ref<boolean>(false)
    const dialogCancelledLoan = ref<boolean>(false)
    const isOpenDialogWaitingDocs = ref<boolean>(false)
    const selectedLoan = ref<any | null>(null)
    const loanId = ref<string | null>(null)

    function markHandOverLoanAsSigned(id: string) {
      dialogMarkHandOverLoanSigned.value = true
      loanId.value = id
    }

    function markLoanAsCancelled(id: string) {
      dialogCancelledLoan.value = true
      loanId.value = id
    }

    function makeReturn(dbLoanSelected: any) {
      root.$store.commit('SET_DEALER_BIKE_LOAN_CONTACT', dbLoanSelected.contact)
      root.$router.push({name: 'ReturnDealerBike', params: {loanId: dbLoanSelected.id}})
    }

    function markReturnLoanAsSigned(id: string) {
      dialogMarkReturnLoanSigned.value = true
      loanId.value = id
    }

    async function signLoan() {
      try {
        await signHandOverLoan(loanId.value as string)
        dialogMarkHandOverLoanSigned.value = !dialogMarkHandOverLoanSigned.value
        emit('refreshList')
      } catch (err) {
        console.error(err)
      }
    }

    async function doCancelledLoan() {
      try {
        await cancelledLoan(loanId.value as string)
        dialogCancelledLoan.value = !dialogCancelledLoan.value
        emit('refreshList')
      } catch (err) {
        console.error(err)
      }
    }

    async function toggleDialogWaitingDocs(loan?: any) {
      isOpenDialogWaitingDocs.value = !isOpenDialogWaitingDocs.value
      if (loan) {
        selectedLoan.value = loan
      } else {
        emit('refreshList')
      }
    }

    async function signReturn() {
      try {
        await signReturnLoan(loanId.value as string)
        dialogMarkReturnLoanSigned.value = !dialogMarkReturnLoanSigned.value
        emit('refreshList')
      } catch (err) {
        console.error(err)
      }
    }

    return {
      resendSignHandoverEmail,
      resendSignReturnEmail,
      markHandOverLoanAsSigned,
      markLoanAsCancelled,
      markReturnLoanAsSigned,
      makeReturn,
      doCancelledLoan,
      toggleDialogWaitingDocs,
      signLoan,
      signReturn,
      LoanStatus,
      dialogMarkHandOverLoanSigned,
      dialogMarkReturnLoanSigned,
      dialogCancelledLoan,
      isOpenDialogWaitingDocs,
      selectedLoan,
      loanId,
    }
  },
})
</script>
